/** App Builder model catalog — grouped by cloud provider key id. */

export const BUILDER_MODEL_GROUPS = [
  {
    keyId: 'openai',
    label: 'OpenAI',
    models: [
      { id: 'gpt-4o-mini', label: 'GPT-4o Mini' },
      { id: 'gpt-4o', label: 'GPT-4o' },
    ],
  },
  {
    keyId: 'anthropic',
    label: 'Anthropic',
    models: [
      { id: 'claude-haiku-4.5', label: 'Claude Haiku 4.5' },
      { id: 'claude-sonnet-4.5', label: 'Claude Sonnet 4.5' },
      { id: 'claude-opus-4.5', label: 'Claude Opus 4.5' },
    ],
  },
  {
    keyId: 'google',
    label: 'Google',
    models: [
      { id: 'gemini-3-flash', label: 'Gemini 3 Flash' },
      { id: 'gemini-3-pro', label: 'Gemini 3 Pro' },
    ],
  },
];

export function isProviderConfigured(cloudKeys, keyId) {
  const entry = cloudKeys?.[keyId];
  return Boolean(entry?.configured || (entry?.api_key && String(entry.api_key).startsWith('••••')));
}

/** Models the user can select based on saved cloud provider keys. */
export function listAvailableBuilderModels(cloudKeys) {
  const available = [];
  for (const group of BUILDER_MODEL_GROUPS) {
    if (!isProviderConfigured(cloudKeys, group.keyId)) continue;
    for (const model of group.models) {
      available.push({ ...model, provider: group.label, keyId: group.keyId });
    }
  }
  return available;
}

export function pickDefaultBuilderModel(cloudKeys, preferred) {
  const available = listAvailableBuilderModels(cloudKeys);
  if (preferred && available.some((m) => m.id === preferred)) return preferred;
  if (available.length) return available[0].id;
  return preferred || 'gpt-4o-mini';
}
